{
  "metadata": {
    "anno_riferimento": 2026,
    "data_ultimo_aggiornamento": "2026-09-14",
    "fonte": "Circolare INPS n. 6/2026 (aliquote, massimale 122.295, prima fascia 56.224); L. 199/2025 (IRPEF 2026: 23/33/43%) e L. 207/2024 art. 1 c. 4-9 (cuneo); art. 13 TUIR (detrazioni); Circolare INAIL n. 35 del 22-07-2026 (minimale e massimale di rendita dal 1-7-2026); Dipartimento delle Finanze - Addizionale regionale all'IRPEF, elenchi generali CSV 2024-2026 (prospetto prodotto il 19-05-2026). Verifica del 14-09-2026."
  },
  "aliquote_regionali": {
    "2024": {
      "Abruzzo": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0173,
        "terzoScaglione": 0.0173,
        "else": 0.0173
      },
      "Basilicata": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Bolzano": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0173
      },
      "Calabria": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0173,
        "terzoScaglione": 0.0173,
        "else": 0.0173
      },
      "Campania": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0296,
        "terzoScaglione": 0.032,
        "else": 0.0333
      },
      "Emilia-Romagna": {
        "primoScaglione": 0.0133,
        "secondoScaglione": 0.0193,
        "terzoScaglione": 0.0203,
        "else": 0.0227
      },
      "Friuli Venezia-Giulia": {
        "primoScaglione": 0.007,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Lazio": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0333,
        "terzoScaglione": 0.0333,
        "else": 0.0333
      },
      "Liguria": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0318,
        "else": 0.0323
      },
      "Lombardia": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0158,
        "terzoScaglione": 0.0172,
        "else": 0.0173
      },
      "Marche": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0153,
        "terzoScaglione": 0.017,
        "else": 0.0173
      },
      "Molise": {
        "primoScaglione": 0.0203,
        "secondoScaglione": 0.0223,
        "terzoScaglione": 0.0363,
        "else": 0.0363
      },
      "Piemonte": {
        "primoScaglione": 0.0162,
        "secondoScaglione": 0.0213,
        "terzoScaglione": 0.0275,
        "else": 0.0333
      },
      "Puglia": {
        "primoScaglione": 0.0133,
        "secondoScaglione": 0.0143,
        "terzoScaglione": 0.0163,
        "else": 0.0185
      },
      "Sardegna": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Sicilia": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Toscana": {
        "primoScaglione": 0.0142,
        "secondoScaglione": 0.0143,
        "terzoScaglione": 0.0332,
        "else": 0.0333
      },
      "Trento": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0173
      },
      "Umbria": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0162,
        "terzoScaglione": 0.0167,
        "else": 0.0183
      },
      "Valle d'Aosta": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Veneto": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      }
    },
    "2025": {
      "Abruzzo": {
        "primoScaglione": 0.0167,
        "secondoScaglione": 0.0167,
        "terzoScaglione": 0.0287,
        "else": 0.0333
      },
      "Basilicata": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Bolzano": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0173
      },
      "Calabria": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0173,
        "terzoScaglione": 0.0173,
        "else": 0.0173
      },
      "Campania": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0296,
        "terzoScaglione": 0.032,
        "else": 0.0333
      },
      "Emilia-Romagna": {
        "primoScaglione": 0.0133,
        "secondoScaglione": 0.0193,
        "terzoScaglione": 0.0293,
        "else": 0.0333
      },
      "Friuli Venezia-Giulia": {
        "primoScaglione": 0.007,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Lazio": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0333,
        "terzoScaglione": 0.0333,
        "else": 0.0333
      },
      "Liguria": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0318,
        "else": 0.0323
      },
      "Lombardia": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0158,
        "terzoScaglione": 0.0172,
        "else": 0.0173
      },
      "Marche": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0153,
        "terzoScaglione": 0.017,
        "else": 0.0173
      },
      "Molise": {
        "primoScaglione": 0.0203,
        "secondoScaglione": 0.0223,
        "terzoScaglione": 0.0363,
        "else": 0.0363
      },
      "Piemonte": {
        "primoScaglione": 0.0162,
        "secondoScaglione": 0.0213,
        "terzoScaglione": 0.0275,
        "else": 0.0333
      },
      "Puglia": {
        "primoScaglione": 0.0133,
        "secondoScaglione": 0.0143,
        "terzoScaglione": 0.0163,
        "else": 0.0185
      },
      "Sardegna": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Sicilia": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Toscana": {
        "primoScaglione": 0.0142,
        "secondoScaglione": 0.0143,
        "terzoScaglione": 0.0332,
        "else": 0.0333
      },
      "Trento": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0173
      },
      "Umbria": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0302,
        "terzoScaglione": 0.0312,
        "else": 0.0333
      },
      "Valle d'Aosta": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Veneto": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      }
    },
    "2026": {
      "Abruzzo": {
        "primoScaglione": 0.0167,
        "secondoScaglione": 0.0167,
        "terzoScaglione": 0.0287,
        "else": 0.0333
      },
      "Basilicata": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Bolzano": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0173
      },
      "Calabria": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0173,
        "terzoScaglione": 0.0173,
        "else": 0.0173
      },
      "Campania": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0296,
        "terzoScaglione": 0.032,
        "else": 0.0333
      },
      "Emilia-Romagna": {
        "primoScaglione": 0.0133,
        "secondoScaglione": 0.0193,
        "terzoScaglione": 0.0278,
        "else": 0.0333
      },
      "Friuli Venezia-Giulia": {
        "primoScaglione": 0.007,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Lazio": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0333,
        "terzoScaglione": 0.0333,
        "else": 0.0333
      },
      "Liguria": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0318,
        "else": 0.0323
      },
      "Lombardia": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0158,
        "terzoScaglione": 0.0172,
        "else": 0.0173
      },
      "Marche": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0153,
        "terzoScaglione": 0.017,
        "else": 0.0173
      },
      "Molise": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0193,
        "terzoScaglione": 0.0333,
        "else": 0.0333
      },
      "Piemonte": {
        "primoScaglione": 0.0162,
        "secondoScaglione": 0.0268,
        "terzoScaglione": 0.0331,
        "else": 0.0333
      },
      "Puglia": {
        "primoScaglione": 0.0133,
        "secondoScaglione": 0.0143,
        "terzoScaglione": 0.0163,
        "else": 0.0185
      },
      "Sardegna": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Sicilia": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Toscana": {
        "primoScaglione": 0.0142,
        "secondoScaglione": 0.0143,
        "terzoScaglione": 0.0332,
        "else": 0.0333
      },
      "Trento": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0173
      },
      "Umbria": {
        "primoScaglione": 0.0173,
        "secondoScaglione": 0.0302,
        "terzoScaglione": 0.0312,
        "else": 0.0333
      },
      "Valle d'Aosta": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      },
      "Veneto": {
        "primoScaglione": 0.0123,
        "secondoScaglione": 0.0123,
        "terzoScaglione": 0.0123,
        "else": 0.0123
      }
    }
  },
  "aliquote_inps": {
    "lavoratore": {
      "regolare": 0.0919,
      "apprendistato": 0.0584,
      "quindici_dipendenti": 0.0949,
      "pubblico": 0.0880
    },
    "azienda": {
      "regolare": 0.2381,
      "apprendistato": 0.1,
      "pubblico": 0.2420
    },
    "massimale2024": 119650,
    "massimale2025": 120607,
    "massimale2026": 122295,
    "primaFascia2024": 52190,
    "primaFascia2025": 55448,
    "primaFascia2026": 56224,
    "aliquotaAggiuntiva": 0.01,
    "esonero2024": {
      "primoScaglione": {
        "sconto": 0.07,
        "soglia": 1923
      },
      "secondoScaglione": {
        "sconto": 0.06,
        "soglia": 2692
      }
    },
    "esonero_madre_lavoratrice": {
      "soglia": 3000
    }
  },
  "inail": {
    "massimale": 38465.70,
    "minimale": 20712.30
  },
  "aliquote_irpef": {
    "default": {
      "primoScaglione": {
        "aliquota": 0.23,
        "scaglioniPrecedenti": 0
      },
      "secondoScaglione": {
        "aliquota": 0.35,
        "scaglioniPrecedenti": 6440
      },
      "else": {
        "aliquota": 0.43,
        "scaglioniPrecedenti": 14140
      }
    },
    "2026": {
      "primoScaglione": {
        "aliquota": 0.23,
        "scaglioniPrecedenti": 0
      },
      "secondoScaglione": {
        "aliquota": 0.33,
        "scaglioniPrecedenti": 6440
      },
      "else": {
        "aliquota": 0.43,
        "scaglioniPrecedenti": 13700
      }
    }
  },
  "dati_reddito": {
    "Abruzzo": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 63624
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 14596
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 11703
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 10142
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 9477
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 8591
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 8661
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 16829
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 16727
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 49976
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 59638
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 53219
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 72802
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 120776
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 149754
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 53815
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 73499
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 33988
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 30755
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 7398
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 5329
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 745
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 2844
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 2668
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 3925
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 2645
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 3069
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 2217
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 1534
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 914
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 603
    }],
    "Basilicata": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 29882
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 6032
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 4988
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 4433
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 4087
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 3701
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 3534
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 7338
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 7316
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 24068
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 27921
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 25204
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 32057
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 47759
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 56211
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 19387
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 27068
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 12465
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 10097
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 2263
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 1739
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 2249
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 859
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 711
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 1164
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 846
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 1068
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 730
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 411
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 237
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 138
    }],
    "Bolzano": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 18748
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 9303
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 6812
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 5122
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 4397
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 4095
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 3597
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 6446
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 5981
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 15832
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 20946
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 17384
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 27047
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 48856
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 65239
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 2938
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 49164
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 26543
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 28468
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 734
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 5056
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 6811
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 2452
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 199
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 3053
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 2254
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 2877
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 2636
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 2167
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 1429
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 915
    }],
    "Calabria": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 85806
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 20589
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 17784
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 16964
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 15123
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 13864
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 13742
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 29441
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 29241
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 9648
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 115469
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 83141
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 93277
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 133316
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 143634
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 51136
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 75944
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 36118
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 29291
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 6405
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 4629
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 6845
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 2675
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 2479
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 4005
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 2515
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 2855
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 1834
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 1189
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 593
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 323
    }],
    "Campania": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 219772
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 57773
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 49455
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 46047
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 43322
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 38055
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 38105
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 75476
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 78393
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 224211
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 252469
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 199588
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 252214
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 384927
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 433538
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 160699
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 244503
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 12114
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 108478
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 25285
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 17529
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 25874
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 986
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 8948
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 14024
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 9448
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 11833
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 8373
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 5366
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 2945
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 1907
    }],
    "Emilia-Romagna": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 141177
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 38784
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 32568
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 29084
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 27542
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 24951
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 24483
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 47319
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 4727
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 117391
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 158718
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 145445
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 241604
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 472077
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 641585
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 249116
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 355228
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 16681
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 168372
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 46674
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 34976
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 48209
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 17878
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 15249
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 23148
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 16238
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 20212
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 15895
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 11719
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 7785
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 5641
    }],
    "Friuli Venezia-Giulia": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 43767
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 11111
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 9167
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 8224
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 7755
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 738
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 6939
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 13392
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 13212
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 3496
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 42765
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 40572
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 65821
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 128298
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 176255
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 7062
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 97925
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 46111
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 43131
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 1092
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 7982
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 11275
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 4341
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 3797
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 5627
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 3912
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 4786
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 355
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 2602
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 1577
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 1052
    }],
    "Italia": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 2138943
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 522713
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 477905
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 389771
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 401055
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 352835
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 328771
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 574441
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 557206
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 1819652
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 2388176
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 2043785
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 2956751
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 5398169
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 6871168
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 2407459
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 3184592
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 1390169
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 1615265
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 414973
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 351384
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 496719
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 165748
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 156347
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 246459
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 153059
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 220671
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 166771
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 94720
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 79973
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 52405
    }],
    "Lazio": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 241463
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 63776
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 49732
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 4305
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 39217
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 35571
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 35428
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 70023
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 68821
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 179629
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 229845
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 192864
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 273307
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 441383
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 549627
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 220507
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 355106
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 20006
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 218324
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 5896
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 42735
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 61858
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 23116
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 19856
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 31987
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 22891
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 28436
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 21933
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 16066
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 9545
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 6773
    }],
    "Liguria": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 5693
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 15784
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 13375
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 11863
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 11025
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 10323
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 10238
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 20595
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 21081
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 5229
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 63772
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 55727
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 86032
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 150283
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 187121
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 74993
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 113064
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 57453
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 5834
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 15317
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 11111
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 15806
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 5796
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 5027
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 7932
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 5636
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 6837
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 5117
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 3903
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 2305
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 1565
    }],
    "Lombardia": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 320912
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 79693
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 68439
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 61074
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 58166
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 52684
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 50804
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 99653
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 10023
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 269252
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 333035
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 302423
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 474614
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 958978
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 1335042
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 522073
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 751388
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 369124
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 386276
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 112812
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 85556
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 121779
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 44669
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 37689
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 58223
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 41851
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 52841
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 42925
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 3417
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 24182
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 19887
    }],
    "Marche": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 53955
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 13856
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 12129
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 10837
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 10285
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 9193
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 9101
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 18054
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 1748
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 50551
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 6372
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 5992
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 92533
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 169879
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 211012
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 70928
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 93178
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 42445
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 40561
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 10818
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 7897
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 11387
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 4216
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 364
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 5596
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 3926
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 4908
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 3727
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 2665
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 1639
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 1106
    }],
    "Molise": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 18734
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 4019
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 3052
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 2656
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 2397
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 214
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 207
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 3915
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 4015
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 13902
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 15219
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 13858
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 16485
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 25324
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 29549
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 11035
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 15323
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 7265
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 5973
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 1343
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 946
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 1356
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 525
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 466
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 749
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 492
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 572
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 420
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 253
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 148
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 72
    }],
    "Piemonte": [{
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 36693
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 31229
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 28102
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 25837
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 23537
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 23371
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 44769
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 43437
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 119766
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 150226
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 139459
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 220098
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 434906
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 597866
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 226988
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 319299
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 151414
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 148696
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 40542
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 29414
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 40747
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 1495
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 12597
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 19746
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 1435
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 17697
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 13706
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 10071
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 6342
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 4361
    }],
    "Puglia": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 217342
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 452
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 35972
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 33035
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 31047
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 27087
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 27142
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 53324
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 55457
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 157035
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 207883
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 165247
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 231933
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 328463
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 356052
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 129518
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 18002
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 86802
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 80545
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 18009
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 12379
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 17711
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 6921
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 6109
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 9685
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 6511
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 7901
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 5638
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 3861
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 2015
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 1099
    }],
    "Sardegna": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 69516
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 15975
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 13657
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 12315
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 11847
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 10938
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 10469
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 2081
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 22198
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 67599
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 75099
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 63698
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 8914
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 145271
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 169843
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 61025
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 80871
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 39237
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 34236
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 8358
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 5943
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 9177
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 3866
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 3186
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 48
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 2983
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 3506
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 2394
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 1568
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 891
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 476
    }],
    "Sicilia": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 238561
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 50603
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 42346
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 37962
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 35018
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 31077
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 29802
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 591
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 62359
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 200605
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 236154
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 185476
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 256342
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 347422
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 364576
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 13071
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 20055
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 100007
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 92718
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 22095
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 15546
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 22242
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 8887
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 7866
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 12218
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 7984
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 9567
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 6338
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 4144
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 2205
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 1153
    }],
    "Toscana": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 120505
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 32418
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 26957
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 24556
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 23818
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 21586
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 21447
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 42696
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 43507
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 117385
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 151692
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 130165
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 208033
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 390885
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 497624
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 182614
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 25248
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 118168
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 119739
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 33182
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 24343
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 34287
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 12899
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 10951
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 17079
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 1192
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 15021
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 11536
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 8363
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 5224
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 3553
    }],
    "Trento": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 21129
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 6336
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 5049
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 4082
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 4056
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 3491
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 3371
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 6234
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 6164
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 17082
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 20172
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 18782
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 29816
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 57153
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 77624
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 33055
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 45842
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 20838
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 19684
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 5421
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 384
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 5214
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 1942
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 1659
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 2589
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 1924
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 2582
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 2122
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 1472
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 881
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 536
    }],
    "Umbria": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 53167
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 816
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 6676
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 6273
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 5656
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 5137
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 4969
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 9834
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 9846
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 28713
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 34441
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 32246
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 5119
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 92073
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 115384
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 41355
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 55949
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 25561
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 22969
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 5741
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 4341
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 6252
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 2443
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 2125
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 3344
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 2178
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 2812
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 1925
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 1312
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 834
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 567
    }],
    "Valle d'Aosta": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 4906
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 1345
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 1172
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 982
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 892
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 804
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 718
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 1375
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 1337
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 3389
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 4552
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 4046
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 6795
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 13008
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 1705
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 6977
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 9885
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 5418
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 5126
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 1299
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 887
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 1234
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 466
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 356
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 580
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 472
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 580
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 433
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 361
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 173
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 102
    }],
    "Veneto": [{
      "Reddito text": "da 0 a 1.000",
      "Reddito Number": 500,
      "Numero contribuenti": 168826
    }, {
      "Reddito text": "da 1.000 a 1.500",
      "Reddito Number": 1250,
      "Numero contribuenti": 42759
    }, {
      "Reddito text": "da 1.500 a 2.000",
      "Reddito Number": 1750,
      "Numero contribuenti": 35643
    }, {
      "Reddito text": "da 2.000 a 2.500",
      "Reddito Number": 2250,
      "Numero contribuenti": 31713
    }, {
      "Reddito text": "da 2.500 a 3.000",
      "Reddito Number": 2750,
      "Numero contribuenti": 30091
    }, {
      "Reddito text": "da 3.000 a 3.500",
      "Reddito Number": 3250,
      "Numero contribuenti": 27198
    }, {
      "Reddito text": "da 3.500 a 4.000",
      "Reddito Number": 3750,
      "Numero contribuenti": 2643
    }, {
      "Reddito text": "da 4.000 a 5.000",
      "Reddito Number": 4500,
      "Numero contribuenti": 5056
    }, {
      "Reddito text": "da 5.000 a 6.000",
      "Reddito Number": 5500,
      "Numero contribuenti": 51616
    }, {
      "Reddito text": "da 6.000 a 7.500",
      "Reddito Number": 6750,
      "Numero contribuenti": 144893
    }, {
      "Reddito text": "da 7.500 a 10.000",
      "Reddito Number": 8750,
      "Numero contribuenti": 181788
    }, {
      "Reddito text": "da 10.000 a 12.000",
      "Reddito Number": 11000,
      "Numero contribuenti": 169249
    }, {
      "Reddito text": "da 12.000 a 15.000",
      "Reddito Number": 13500,
      "Numero contribuenti": 261908
    }, {
      "Reddito text": "da 15.000 a 20.000",
      "Reddito Number": 17500,
      "Numero contribuenti": 507132
    }, {
      "Reddito text": "da 20.000 a 26.000",
      "Reddito Number": 23000,
      "Numero contribuenti": 711927
    }, {
      "Reddito text": "da 26.000 a 29.000",
      "Reddito Number": 27500,
      "Numero contribuenti": 269167
    }, {
      "Reddito text": "da 29.000 a 35.000",
      "Reddito Number": 32000,
      "Numero contribuenti": 358051
    }, {
      "Reddito text": "da 35.000 a 40.000",
      "Reddito Number": 37500,
      "Numero contribuenti": 162411
    }, {
      "Reddito text": "da 40.000 a 50.000",
      "Reddito Number": 45000,
      "Numero contribuenti": 15992
    }, {
      "Reddito text": "da 50.000 a 55.000",
      "Reddito Number": 52500,
      "Numero contribuenti": 44289
    }, {
      "Reddito text": "da 55.000 a 60.000",
      "Reddito Number": 57500,
      "Numero contribuenti": 32662
    }, {
      "Reddito text": "da 60.000 a 70.000",
      "Reddito Number": 65000,
      "Numero contribuenti": 45661
    }, {
      "Reddito text": "da 70.000 a 75.000",
      "Reddito Number": 72500,
      "Numero contribuenti": 16472
    }, {
      "Reddito text": "da 75.000 a 80.000",
      "Reddito Number": 77500,
      "Numero contribuenti": 14045
    }, {
      "Reddito text": "da 80.000 a 90.000",
      "Reddito Number": 85000,
      "Numero contribuenti": 21737
    }, {
      "Reddito text": "da 90.000 a 100.000",
      "Reddito Number": 95000,
      "Numero contribuenti": 15726
    }, {
      "Reddito text": "da 100.000 a 120.000",
      "Reddito Number": 110000,
      "Numero contribuenti": 20711
    }, {
      "Reddito text": "da 120.000 a 150.000",
      "Reddito Number": 135000,
      "Numero contribuenti": 16517
    }, {
      "Reddito text": "da 150.000 a 200.000",
      "Reddito Number": 175000,
      "Numero contribuenti": 12276
    }, {
      "Reddito text": "da 200.000 a 300.000",
      "Reddito Number": 250000,
      "Numero contribuenti": 8109
    }, {
      "Reddito text": "oltre 300.000",
      "Reddito Number": 300000,
      "Numero contribuenti": 576
    }]
  }
}
